import { getItem, setItem } from 'mini-localstorage';
import {
    createDefaultUserCohortActivity,
    UserActivityKeys,
    type UserCohortData,
} from '../schema/UserCohortData';

const COHORT_DATA = 'miniCohort';

/**
 *  Sets the cohort data in local storage.
 * @param cohortData
 */

export const setCohortDataInLocalStorage = (cohortData: UserCohortData): void => {
    setItem(COHORT_DATA, cohortData);
};

/**
 * Gets the cohort data in local storage.
 * @returns
 */
export const getCohortDataInLocalStorage = (): UserCohortData => {
    if (!getItem(COHORT_DATA)) {
        setItem(COHORT_DATA, {
            [UserActivityKeys.userWeeklyActivity]: createDefaultUserCohortActivity(),
            [UserActivityKeys.userMonthlyActivity]: createDefaultUserCohortActivity(),
        });
    }
    return getItem(COHORT_DATA);
};
